import { useCallback, useEffect, useState } from 'react';
import apiClient from '@utils/api-client';
import { publicUploadUrlApiInternalSubcontractorSubcontractWorkStatusPath } from '@routes';
const useGetEasyUploadLink = (id) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const fetchEasyUploadLink = useCallback((params) => {
        setLoading(true);
        apiClient
            .get(publicUploadUrlApiInternalSubcontractorSubcontractWorkStatusPath(params.fetchId), {
            signal: params.controller.signal
        })
            .then((response) => {
            const result = response.data.data;
            setData(result);
        })
            .catch((err) => {
            if (!params.controller.signal.aborted) {
                setData(null);
                setError(err);
            }
        })
            .finally(() => {
            if (!params.controller.signal.aborted) {
                setLoading(false);
            }
        });
    }, []);
    useEffect(() => {
        const controller = new AbortController();
        fetchEasyUploadLink({ fetchId: id, controller });
        return () => {
            controller.abort();
        };
    }, [id]);
    return { data, loading, error };
};
export default useGetEasyUploadLink;
